export default function SyntheseConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('synthesemodeles');
    $translatePartialLoaderProvider.addPart('synthesetype');
    $translatePartialLoaderProvider.addPart('syntheseentities');
}

SyntheseConfiguration.$inject = ['$translatePartialLoaderProvider'];
